import { TenantCommonData } from './common/tenantCommonData';

export class Message extends TenantCommonData {
  senderId: string;
  senderType: string;
  recipientId: string;
  recipientType: string;
  subject: string;
  message: string;
  readingDate: Date;
  useEmailSentDate: Date;
  useEmail: boolean;
  useSmsSentDate: Date;
  useSms: boolean;
  useWhatsAppSentDate: Date;
  useWhatsApp: boolean;
  useInternalSentDate: Date;
  useInternal: boolean;
  groupId: string;

  constructor() {
    super();
    this.senderId = null;
    this.senderType = 'user';
    this.recipientId = null;
    this.recipientType = null;
    this.subject = null;
    this.message = null;
    this.readingDate = null;
    this.useEmailSentDate = null;
    this.useEmail = false;
    this.useSmsSentDate = null;
    this.useSms = false;
    this.useWhatsAppSentDate = null;
    this.useWhatsApp = false;
    this.useInternalSentDate = null;
    this.useInternal = true;
    this.groupId = null;
  }
}
/*
*********** MODELLO DI BACKEND **********************
package com.xfarm.api.v1.comunication

c

class Message {

    Long    id
    string  senderId
    string  senderType
    string  recipientId
    string  recipientType
    string  subject
    string  message
    Date    readingDate
    Date    useEmailSentDate
    boolean useEmail            = false
    Date    useSmsSentDate
    boolean useSms              = false
    Date    useWhatsAppSentDate
    boolean useWhatsApp         = false
    Date    useInternalSentDate
    boolean useInternal         = true
    string  groupId


    Date    dateCreated
    Date    lastUpdated

    static constraints = {
        senderId            blank: false, nullable: false
        senderType          blank: false, nullable: false, inList: ['user', 'farm']
        recipientId         blank: false, nullable: false
        recipientType       blank: false, nullable: false, inList: ['user', 'farm', 'phone-number']
        subject             blank: false, nullable: false
        message             blank: false, nullable: true
        readingDate         blank: false, nullable: true
        useEmailSentDate    blank: false, nullable: true
        useEmail            blank: false, nullable: false
        useSmsSentDate      blank: false, nullable: true
        useSms              blank: false, nullable: false
        useWhatsAppSentDate blank: false, nullable: true
        useWhatsApp         blank: false, nullable: false
        useInternalSentDate blank: false, nullable: true
        useInternal         blank: false, nullable: false
        groupId             blank: false, nullable: true
    }


    static mapping = {
        autoTimestamp true
    }
}


*/
